import React, { useCallback, useRef } from "react";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calender.svg";
import "../../../css/DesignSystem/Inputs/NewDateField.css";

const NewDateField = ({
  id,
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  readOnly = false,
  error = false,
  helperText = "",
}) => {
  const inputRef = useRef(null);
  const inputId =
    id ||
    `date-${String(label || "field")
      .replace(/\s+/g, "-")
      .toLowerCase()}`;
  const inputValue =
    value instanceof Date && !Number.isNaN(value.getTime())
      ? [
          value.getFullYear(),
          String(value.getMonth() + 1).padStart(2, "0"),
          String(value.getDate()).padStart(2, "0"),
        ].join("-")
      : value || "";

  const openCalendar = useCallback(() => {
    if (disabled) return;
    inputRef.current?.focus();
    try {
      inputRef.current?.showPicker?.();
    } catch {
      // Browsers without showPicker still focus the native date input.
    }
  }, [disabled]);

  return (
    <div className="AnnouncementInputField">
      {label && (
        <label
          htmlFor={inputId}
          className="AnnouncementInputField__Label FP_Content text-black"
        >
          {label}{" "}
          {required && (
            <span className="FP_Content_Semibold text-error">*</span>
          )}
        </label>
      )}
      <div className="fp-date-input-wrapper" onClick={openCalendar}>
        <input
          ref={inputRef}
          id={inputId}
          type="date"
          value={inputValue}
          onChange={readOnly ? undefined : onChange}
          onKeyDown={readOnly ? (event) => event.preventDefault() : undefined}
          disabled={disabled}
          aria-readonly={readOnly}
          className={`FP_Content fp-form-input fp-date-input ${error ? "fp-form-input--error" : ""}`}
        />
        <button
          type="button"
          className="fp-date-calendar-button"
          onClick={(event) => {
            event.stopPropagation();
            openCalendar();
          }}
          disabled={disabled}
          aria-label={`Open ${label || "date"} calendar`}
        >
          <CalendarIcon aria-hidden="true" />
        </button>
      </div>
      {error && helperText && (
        <p className="AnnouncementInputField__Error">{helperText}</p>
      )}
    </div>
  );
};

export default NewDateField;
